import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { OnboardingRoutingModule } from './onboarding-routing.module';
import { OnboardingHomeComponent } from './pages/onboarding-home/onboarding-home.component';
import { SharedModule } from '@app/shared/shared.module';
import { OnboardingItemComponent } from './components/onboarding-item/onboarding-item.component';
import { CountCompletedOnboardingPipePipe } from './pipes/count-completed-onboarding-pipe.pipe';

import { ParentStepCountPipe } from './pipes/parent-step-count.pipe';

@NgModule({
  declarations: [
    OnboardingHomeComponent,
    OnboardingItemComponent,
    CountCompletedOnboardingPipePipe,
    ParentStepCountPipe,
  ],
  imports: [CommonModule, OnboardingRoutingModule, SharedModule],
})
export class OnboardingModule {}
